import { useQuery } from '@tanstack/react-query';
import { contentApi } from '../api/content';

export const useContentItems = (contentType?: string, locale?: string) => {
  return useQuery({
    queryKey: ['content', contentType, locale],
    queryFn: () => contentApi.list(contentType, locale),
    staleTime: 30000,
  });
};

export const useContentItem = (id: string) => {
  return useQuery({
    queryKey: ['content', id],
    queryFn: () => contentApi.get(id),
    enabled: !!id,
  });
};

export const useContentStats = () => {
  return useQuery({
    queryKey: ['content', 'stats'],
    queryFn: async () => {
      const all = await contentApi.list();
      return {
        total: all.length,
        published: all.filter((c) => c.status === 'PUBLISHED').length,
        draft: all.filter((c) => c.status === 'DRAFT').length,
        archived: all.filter((c) => c.status === 'ARCHIVED').length,
      };
    },
    staleTime: 60000,
  });
};
